import { Button, IconButton } from '@chakra-ui/button';
import { Flex, Text, Image, useColorModeValue } from '@chakra-ui/react';
import { useRemoveClient } from './useRemoveClient';
import { AiOutlineDelete } from 'react-icons/ai';

export interface GhostwriterClientTileProps {
  client: any;
  setSelectedCreator: (client: any) => void;
  setTabIndex: (index: number) => void;
}

export const GhostwriterClientTile = ({
  client,
  setSelectedCreator,
  setTabIndex,
}) => {
  const bg = useColorModeValue('white', 'gray.800');
  const { onOpen, isLoading, RemovePopup } = useRemoveClient(client);

  return (
    <Flex
      bg={bg}
      onClick={() => {
        setSelectedCreator(client);
        setTabIndex(1);
      }}
      w="250px"
      p={4}
      // pb={2}
      rounded="lg"
      cursor={'pointer'}
      flexDir="column"
      key={client.twUserName}
    >
      <Flex h={'50px'}>
        {client?.image && (
          <Image w="10" h="10" rounded="full" src={client.image} />
        )}
        <Flex ml={2} flexDir={'row'}>
          <Text fontWeight={600}>{client.name}</Text>
          {client.twUserName && (
            <Text fontSize="sm" noOfLines={2} wordBreak={'break-all'}>
              @{client.twUserName}
            </Text>
          )}
          <IconButton
            aria-label="remove-client"
            variant="ghost"
            size="xs"
            isLoading={isLoading}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onOpen();
            }}
            icon={<AiOutlineDelete />}
          />
          <RemovePopup />
        </Flex>
      </Flex>
      <Flex mt={4}>
        <Button
          variant="ghost"
          onClick={() => {
            setSelectedCreator(client);
            setTabIndex(1);
          }}
        >
          Check Content
        </Button>
        <Button
          as="a"
          href={'https://app.taplio.com/write?handle=' + client?.twUserName}
          target="_blank"
          ml={2}
          variant="secondary"
        >
          New Post
        </Button>
      </Flex>
    </Flex>
  );
};
